import axios from "axios";

export async function initiatePayment(data) {
  try {
    let response = await axios.post(
      `${process.env.SERVER_BASE_URL}/durga-puja-2025/payment/initiate`,
      data
    );
    return response?.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}
